import type { ScheduleCallbackType } from "@/shared-types";
import type { CallbackRadioOption } from "./types";

/**
 * @param value - The radio option selected by the expert
 * @returns The SDK callback type for the selected radio option
 */
export const callbackTypeFromRadio = (value: CallbackRadioOption): ScheduleCallbackType => {
    switch (value) {
        case "callback-user-now":
            return "CallbackNow";
        case "callback-user-with-delay":
            return "CallbackNow";
    }
};
export const callbackActionConfig = {
    back: {
        testId: "callback-form-back-button",
        actionId: "Back_CloseScheduleCallback",
    },
    cancel: {
        testId: "callback-form-cancel-button",
        actionId: "CancelScheduleCallback",
    },
    schedule: {
        testId: "call-controls-callback-form-schedule-or-update-button",
        actionId: "ScheduleCallback",
    },
};
